import React, {useState} from 'react';
import {ITags} from "../../../../public/NewsPage/news";
import '../../../adminPage.scss'
import Modal from "../../../../../components/modal/modal";
import UpdateTag from "../UpdateTag/UpdateTag";

interface ITagsList{
    tags: ITags,
    deleteTag: (currentTag: ITags) => void
}

const TagsList = ({tags, deleteTag}: ITagsList) => {
    const [showTagModal, setShowTagModal] = useState(false)

    const closeModal = () => {
        setShowTagModal(false)
    }

    return (
        <section className={'admin_tags_card'}>
             <h2>{tags.name}</h2>
            <div className={'admin_tags_card_buttons'}>
            <button
                className={'button updateBtn'}
                onClick={() => setShowTagModal(true)}
            >
                Обновить
            </button>
            {showTagModal &&
                <Modal
                    active={showTagModal}
                    title={'Введите новое имя тега'}
                    сlose={closeModal}
                >
                    <UpdateTag tag={tags} close={closeModal}/>
                </Modal>
            }

            <button
                className={'button deleteBtn'}
                onClick={() => deleteTag(tags)}
            >
                Удалить
            </button>
            </div>
        </section>
    );
};

export default TagsList;